import {SectionItem} from 'common/components/items-menu/types';

export const ANY_EVENT: SectionItem = {
  icon: `event`,
  label: `Any event`,
  value: `$mp_anything_event`,
};

export const SESSION_START_EVENT: SectionItem = {
  icon: `stop-watch`,
  label: `Session Start`,
  value: `$session_start`,
  name: `$session_start`,
};

export const SESSION_END_EVENT: SectionItem = {
  icon: `stop-watch`,
  label: `Session End`,
  value: `$session_end`,
  name: `$session_end`,
};
